
import ContactForm from "./contact/ContactForm";
import ContactInfo from "./contact/ContactInfo";

const Contact = () => {
  return (
    <section id="contact" className="relative py-24 bg-gradient-to-br from-trust-deep to-authority-navy overflow-hidden">
      {/* Modern Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#FFFFFF_1px,transparent_1px)] [background-size:32px_32px]"></div>
      
      <div className="container-custom relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16 reveal-slide" style={{ '--reveal-delay': 0 } as React.CSSProperties}>
          <div className="inline-block px-4 py-2 mb-6 rounded-full bg-trust-light text-trust-deep font-semibold text-sm border border-trust-primary/20">
            🤝 Get In Touch
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-neutral-white">
            Ready to Solve Your Plumbing Problems?
          </h2>
          <p className="text-xl text-trust-light/90">
            Contact Colorado First Plumbing for professional service, transparent pricing, and expert solutions. 
            We're here to help with all your plumbing needs.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
          <div className="col-span-1 lg:col-span-2 order-2 lg:order-1 reveal-slide" style={{ '--reveal-delay': 1 } as React.CSSProperties}>
            <ContactInfo />
          </div>
          
          <div className="col-span-1 lg:col-span-3 order-1 lg:order-2 reveal-slide" style={{ '--reveal-delay': 2 } as React.CSSProperties}>
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
